import {injectable} from 'inversify';

import type {FollowerModel} from './Follower.model';

import {BaseController} from '../Base/Base.controller';

@injectable()
export class FollowerController extends BaseController<FollowerModel> {
  constructor() {
    super();
  }
}
